module.exports = __webpack_public_path__ + "static/media/Money1.0f3fe000.svg";